/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';

import Autocomplete from '../../../Form/Autocomplete';


const PureReusableComponent = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  let _isMounted = false;
  const initialState = {
    type: 'ReusableComponent',
    components: [
      {
        key: '',
      },
    ],
  };


  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [allPosts, setAllPosts] = useState([]);
  const [compUpdated, setCompUpdated] = useState([{
    key: '',
  }]);

  const getPosts = async () => {
    try {
      const res = await getPostsByType('component');
      if (res && _isMounted) {
        const { posts } = res;
        const routePosts = posts.map(post => post.slugName);
        setAllPosts(routePosts);
        setIsLoading(false);
      }
    } catch {
      err => console.log(err, ' => getPostsByCategory');
    }
  };

  useEffect(() => {
    _isMounted = true;
    getPosts();
    return () => {
      _isMounted = false;
    };
  }, []);

  const storeText = (currField, val) => {
    const { component } = components[index];


    const compUpdatedAdj = [{ key: val.toLowerCase() }];

    setCompUpdated(compUpdatedAdj);

    const comp = {
      ...component,
      components: compUpdatedAdj
      ,
    };


    setState(comp);


    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };


  useEffect(() => {
    if (_isMounted) {
      const componentIndex = components.findIndex(obj => obj.id === id);
      const { component } = components[componentIndex];
      if (reusableComponent) {
        setState(reusableComponent);
        if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
      } else {
        setIndex(componentIndex);
        if (component) {
          setCompUpdated(component.components);
          setState(component);
        } else {
          const componentObj = {
            id,
            component: state,
          };

          handlerSetComponents(componentObj, componentIndex);
        }
      }
    }
  }, [components]);


  return (
    <>

      {!isLoading && (
        <div className="w-full bg-greyFilter pl-12 rounded justify-around flex flex-row">
          <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black w-full pr-4" htmlFor="slugA">
            <Autocomplete title="Post Slugname" name="postSlugName" message="The post slug does not exist" suggestions={allPosts} storeText={storeText} action="create" value={compUpdated[0].key.toLowerCase()} />
          </label>
        </div>
      )}

    </>
  );
};

PureReusableComponent.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
PureReusableComponent.defaultProps = {
  reusableComponent: null,
};

export default PureReusableComponent;
